import { useEffect, useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { WHATSAPP_URL } from "../../lib/constants";

export default function WhatsAppFab() {
    const [show, setShow] = useState(false);
    const [hint, setHint] = useState(true);

    useEffect(() => {
        const t = setTimeout(() => setShow(true), 1500);
        const h = setTimeout(() => setHint(false), 8000);
        return () => {
            clearTimeout(t);
            clearTimeout(h);
        };
    }, []);

    if (!show) return null;

    return (
        <div className="fixed bottom-5 right-5 z-50 flex items-end gap-2">
            {hint && (
                <div className="hidden sm:flex relative bg-[#0F0F0F] border border-brand-orange/40 text-brand-text text-sm pr-8 pl-4 py-3 max-w-[220px] shadow-lg">
                    <button
                        onClick={() => setHint(false)}
                        aria-label="Cerrar"
                        className="absolute top-1 right-1 text-brand-muted hover:text-brand-text"
                    >
                        <X size={14} />
                    </button>
                    <span>
                        ¿Listo para empezar?{" "}
                        <span className="text-brand-orange font-medium">
                            Te respondemos al momento.
                        </span>
                    </span>
                </div>
            )}
            <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noreferrer"
                data-testid="whatsapp-fab"
                className="relative w-16 h-16 bg-brand-orange hover:bg-brand-orangeHover text-black flex items-center justify-center transition-all hover:scale-110 shadow-[0_0_30px_rgba(255,94,0,0.5)]"
                aria-label="Contactar por WhatsApp"
            >
                <MessageCircle size={28} strokeWidth={2} />
                <span className="absolute inset-0 pulse-dot" />
            </a>
        </div>
    );
}
